import { render, staticRenderFns } from "./ConfirmedOrders.vue?vue&type=template&id=78c4b672"
import script from "./ConfirmedOrders.vue?vue&type=script&lang=js"
export * from "./ConfirmedOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports